import React, { ReactElement } from 'react'
import { useSession } from 'next-auth/react'
import { useRouter } from 'next/router'
import AuthContent from '../organisms/AuthContent'
import { Social } from '@/types/auth'
import { LoginCandidateFormProps } from '../molecules/LoginCandidateForm'

interface IProps {
  data: Social[]
  title: string | React.ReactNode
  CredentialForm?: ({
    withResetPassword,
    withForgotPassword,
  }: LoginCandidateFormProps) => JSX.Element
}

const Auth = ({ data, title, CredentialForm }: IProps) => {
  const { data: session } = useSession()
  const router = useRouter()
  let redirectSlug = ''

  if (session && session?.authToken?.includes('candidate')) {
    const queryAmount = Object.keys(router.query).length
    redirectSlug += router.query.redirect

    if (queryAmount > 1) {
      redirectSlug += '?'
    }

    Object.keys(router.query).forEach((param, index) => {
      if (param === 'redirect') {
        return
      }

      redirectSlug += `${param}=${router.query[param]}`

      if (index < queryAmount - 1) {
        redirectSlug += '&'
      }
    })

    setTimeout(() => {
      router.push(
        typeof router.query.redirect === 'string'
          ? redirectSlug
          : '/account/guide'
      )
    }, 100)
    return null
  }

  return (
    <main>
      <div className='container relative'>
        <div className='container-small'>
          <div className='mt-14'>
            <AuthContent
              data={data}
              title={title}
              CredentialForm={CredentialForm}
            />
          </div>
        </div>
      </div>
    </main>
  )
}

export default Auth
